import { css, CSSResult } from 'lit'
import { csColorAction, csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cseRangeSlider = {
  backgroundColor: css`var(--cse-range-slider-background-color, ${csColorAction.linkPrimary})`,
  backgroundColorUnselected: css`var(--cse-range-slider-background-color-unselected, ${csColorBorder.light})`,

  thumbBackgroundColor: css`var(--cse-range-slider-thumb-background-color, ${csColorBackground.primary})`,
  thumbBorderColor: css`var(--cse-range-slider-thumb-border-color, ${csColorAction.linkPrimary})`,
}

export const style: CSSResult = css`
  .cse-range-slider {
    display: grid;
  }

  input[type="range"] {
    --color: ${cseRangeSlider.backgroundColor};
    -webkit-appearance: none;
    background: linear-gradient(90deg, transparent var(--start), var(--color) var(--start), var(--color) var(--stop), transparent var(--stop)), ${cseRangeSlider.backgroundColorUnselected};
    grid-column: 1;
    grid-row: 1;
    height: 3px;
    pointer-events: none;
    max-width: 100%;
    width: 100%;
  }

    /* Firefox fix */
  input[type="range"] ~ input {
    background: initial;
  }

  input[type="range"]:disabled {
    --color: ${cseRangeSlider.backgroundColorUnselected};
  }

  /* Thumb */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: ${cseRangeSlider.thumbBackgroundColor};
    border-radius: 50%;
    border: 3px solid ${cseRangeSlider.thumbBorderColor};
    height: 25px;
    pointer-events: auto;
    width: 25px;
  }

  input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    background-color: ${cseRangeSlider.thumbBackgroundColor};
    border-radius: 50%;
    border: 3px solid ${cseRangeSlider.thumbBorderColor};
    height: 25px;
    pointer-events: auto;
    width: 25px;
  }

  input[type="range"]::-ms-thumb {
    -webkit-appearance: none;
    background-color: ${cseRangeSlider.thumbBackgroundColor};
    border-radius: 50%;
    border: 3px solid ${cseRangeSlider.thumbBorderColor};
    height: 25px;
    pointer-events: auto;
    width: 25px;
  }

  /* Track */
  input[type="range"]::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    border: none;
    box-shadow: none;
  }

  input[type="range"]::-moz-range-track {
    -webkit-appearance: none;
    border: none;
    box-shadow: none;
  }

  input[type="range"]::-ms-track {
    -webkit-appearance: none;
    border: none;
    box-shadow: none;
  }

  .sr-only {
    position: absolute;
    clip-path: inset(50%);
  }
`
